<div class="w-100 p-3 f-16 rounded"
     [style.background-color]="backgroundColor"
     [style.color]="textColor">
     {{ header | translate }}
</div>
